import { styled } from '@material-ui/core/styles'

export const FooterNotice = styled('div')(({ theme: { breakpoints } }) => ({
  marginTop: 48,
  [breakpoints.up('md')]: {
    marginTop: 24,
  },
  '@media (min-width: 1008px)': {
    marginTop: 64,
  },
}))
